import styles from "./accordion.module.css";

interface AccordionProps {
  children: React.ReactNode;
}
function Accordion({ children }: AccordionProps) {
  return <div className={styles.accordion}>{children}</div>;
}

export default Accordion;
